import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../api/client'
import { useForbiddenGuard } from '../api/guard'
import './screens.css'

interface AuthConfig {
  provider: string
  display_name: string
  client_id: string
  authorize_url: string
  token_url: string
  scopes: string[]
  user_scopes: string[]
  enabled: boolean
  created_at: string
  updated_at: string
}
interface AuthConfigsResponse {
  configs: AuthConfig[]
}

export function AuthConfigsView() {
  const query = useQuery<AuthConfigsResponse>({
    queryKey: ['admin-auth-configs'],
    queryFn: () => apiFetch<AuthConfigsResponse>('/admin/auth-configs'),
  })
  useForbiddenGuard(query.error)

  const configs = query.data?.configs ?? []

  return (
    <section className="ac" aria-labelledby="ac-heading">
      <div className="screen-head">
        <h2 id="ac-heading">Auth Configs</h2>
      </div>

      {query.isError && (query.error as { status?: number }).status !== 403 && (
        <p className="screen-error" role="alert">
          Failed to load auth configs.
        </p>
      )}

      <table className="ac-table">
        <thead>
          <tr>
            <th>Provider</th>
            <th>Display name</th>
            <th>Client ID</th>
            <th>Scopes</th>
            <th>Enabled</th>
          </tr>
        </thead>
        <tbody>
          {configs.map((c) => (
            <tr key={c.provider}>
              <td>{c.provider}</td>
              <td>{c.display_name}</td>
              <td>
                <code>{c.client_id}</code>
              </td>
              <td>{(c.scopes ?? []).join(', ')}</td>
              <td>{c.enabled ? 'Yes' : 'No'}</td>
            </tr>
          ))}
          {!query.isLoading && configs.length === 0 && (
            <tr>
              <td colSpan={5} className="ws-empty">
                No auth configs.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  )
}
